module.exports = __webpack_public_path__ + "static/adobe_logo-9e4972ce74f87ff2ecffbb51385a9faf.png";